/**
 * @file Comportement d'arme 'explosive' : Explosif (lance-grenades, canons) : projectile lent qui explose au premier impact ou en fin de portee.
 */
import type { SimContext } from '../../Context';
import { explode, rollCrit } from '../../combat/damage';
import type { With } from '../../ecs/World';
import { DEG } from '../../math/geometry';
import { spawnProjectile } from '../projectiles';
import type { HitOutcome, ShotContext, WeaponBehaviorModule } from '../WeaponBehavior';
import { announceShot } from './common';

const blast = (ctx: SimContext, proj: With<'projectile'>): void => {
  const pr = proj.projectile;
  explode(ctx, proj.transform.x, proj.transform.y, pr.explosionRadius, pr.damage, pr.crit, 'explosive', ctx.config.behaviors.explosive.explosionFalloffAtEdge);
};

/** fire : grenade lente ; explose au premier impact (la cible touchee est dans la zone) ou en fin de portee. */
export const explosiveBehavior: WeaponBehaviorModule = {
  id: 'explosive',
  fire(ctx: SimContext, shot: ShotContext): void {
    const { weapon: w, cat } = shot;
    const p = w.params;
    const angle = shot.aimAngle + ctx.rng.combat.range(-1, 1) * (p.spreadMinDeg / 2) * DEG;
    const roll = rollCrit(ctx, w, w.damage);
    const proj = spawnProjectile(ctx, {
      kind: 'grenade',
      behavior: 'explosive',
      ownerId: cat.id,
      weaponDefId: w.def.id,
      slot: w.slot,
      x: shot.originX,
      y: shot.originY,
      angle,
      speed: p.projectileSpeed,
      radius: p.projectileRadius,
      range: w.range,
      damage: roll.damage,
      crit: roll.crit,
      explosionRadius: w.explosionRadius,
    });
    announceShot(ctx, shot, 'explosive', [proj.id]);
  },
  onHit(ctx: SimContext, proj: With<'projectile'>): HitOutcome {
    blast(ctx, proj);
    return { consumed: true };
  },
  onExpire(ctx: SimContext, proj: With<'projectile'>): void {
    blast(ctx, proj);
  },
};
